var _path;
import * as React from "react";
function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 18.754a.75.75 0 00-.75-.75h-1.5a.75.75 0 00-.75.75v5.251h-3.055a.75.75 0 00-.528 1.283l4.52 4.485a.8.8 0 001.126 0l4.52-4.485a.75.75 0 00-.529-1.283H21.5v-5.25zm9.614-8.63L25.871 4.88A3 3 0 0023.753 4H11a3.01 3.01 0 00-3 3.006V33a3 3 0 003 3h17.996A3.004 3.004 0 0032 33V12.249c0-.793-.323-1.562-.886-2.124zm-7.117-2.875l4.756 4.755h-4.756V7.25zM29 33.001H11V7.006h9.997v6.498c0 .832.67 1.5 1.5 1.5H29V33z"
  })));
}
export default SvgDownload;